module.exports = __webpack_public_path__ + "static/Competetive Rates Icon-b036baabcd94fc08e3e3b6ee6d16148b.svg";